import { IconExternalLink } from '@tabler/icons-react'

import { AstraCallout } from '~/astra'
import env from '~/env'
import { Incident } from '~/hooks/tanstack-query/betterstack/utils'

import { BannerText } from './BannerText'

export const IncidentBanner = ({ title, latestUpdateMessage, latestUpdateTimestamp, aggregateState }: Incident) => (
    <AstraCallout
        color={aggregateState === 'downtime' ? 'critical' : 'caution'}
        text={<BannerText title={title} latestUpdateMessage={latestUpdateMessage} latestUpdateTimestamp={latestUpdateTimestamp} />}
        action={{
            icon: <IconExternalLink />,
            onClick: () => window.open(env.VITE_BETTERSTACK_STATUS_PAGE_URL, '_blank'),
        }}
        data-test="incident-banner"
    />
)
